export const environment = {
    appName: 'Clinng Voucher CERT',
    production: false,
    apiConfig: {
      cashProcessorUrl: 'https://cert.experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/payment/voucher',
      payinCheckoutBackendUrl: 'https://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/',
      websocket: "wss://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/ws",
      payinMetricExperienceUrl: 'https://cert.payin.experience.monnet.io/ms-payin-metric-experience',
      virtualAccountsApiUrl: 'https://cert.virtual-accounts.monnet.io/account-voucher-api/v1',
    }
  };
